export default __webpack_public_path__ + "static/heroSectionBackground-55ce7eb2e7ea25baa0b6fd19d98b8087.png";